import _get from 'lodash/get';


const getErrors = state => _get(state, 'siteGoogleAnalytics.errors');
export const getLoadSiteGoogleAnalyticsError = state => (
  _get(getErrors(state), 'loadSiteGoogleAnalyticsError')
);
export const getEditSiteGoogleAnalyticsError = state => (
  _get(getErrors(state), 'editSiteGoogleAnalyticsError')
);
